import React, { Component } from 'react';
import { Tag, HTMLTable, InputGroup, Button, Intent, Card, Elevation } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class Logs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isStreaming: true,
      search: '',
      severityFilter: 'ALL',
      logs: [
        { time: '14:44:12.981', level: 'EXPLOIT_BLOCKED', player: 'GoldCeo', ip: '109.90.**.**', details: 'Blocked Opcode 0x7021 (SpeedHack packet injection attempt). IP rate limited.' },
        { time: '14:43:58.204', level: 'LOGIN', player: 'Nozich', ip: '85.102.**.**', details: 'Character Nozich authenticated on Gateway Server (HWID: 4D8A-99F1)' },
        { time: '14:43:10.112', level: 'ALCHEMY', player: 'Merlin', ip: '178.240.**.**', details: 'Alchemy Plus Event: Upgraded Paradise Jewel Ring to +11 (Lucky Powder active)' },
        { time: '14:42:01.884', level: 'PC_LIMIT', player: 'edjka1985_alt', ip: '185.93.**.**', details: 'Rejected 3rd connection attempt on IP 185.93.**.** [PC/IP Limit enforced = 2 Max]' },
        { time: '14:41:22.500', level: 'TRADE', player: 'FR_Henry', ip: '92.44.**.**', details: 'Trade completed: Transferred 2,000,000,000 Gold to character Asviix' },
        { time: '14:40:05.119', level: 'EXPLOIT_BLOCKED', player: 'HackerX', ip: '45.14.**.**', details: 'Blocked Opcode 0x3012 (Stall item dupe exploit attempt). Account flagged.' },
        { time: '14:38:49.001', level: 'UNIQUE_KILL', player: 'Merlin', ip: '178.240.**.**', details: 'Unique Killed: Tiger Girl in Jangan Tiger Mountain (Drop: Sun Ring 8DG)' },
        { time: '14:37:12.440', level: 'GLOBAL_CHAT', player: 'Sharpknife', ip: '127.0.0.1', details: 'Global Sent: "THX HandOfGod for 2 Bil Silkroad Online Giveaway :)"' },
        { time: '14:35:00.000', level: 'SECURITY_ALERT', player: 'System', ip: '127.0.0.1', details: 'SROFilter Automated Exploit Guard Scan completed: 0 active vulnerabilities.' },
      ]
    };
  }

  renderLevelTag(level) {
    switch (level) {
      case 'EXPLOIT_BLOCKED':
        return <Tag intent={Intent.DANGER} round icon="shield">EXPLOIT BLOCKED</Tag>;
      case 'SECURITY_ALERT':
        return <Tag intent={Intent.WARNING} round icon="warning-sign">SECURITY ALERT</Tag>;
      case 'PC_LIMIT':
        return <Tag intent={Intent.WARNING} round icon="ip-address">PC/IP LIMIT</Tag>;
      case 'LOGIN':
        return <Tag intent={Intent.SUCCESS} round icon="log-in">LOGIN SUCCESS</Tag>;
      case 'ALCHEMY':
        return <Tag intent={Intent.PRIMARY} round icon="lab-test">ALCHEMY PLUS</Tag>;
      case 'TRADE':
        return <Tag intent={Intent.SUCCESS} round icon="exchange">TRADE LOG</Tag>;
      default:
        return <Tag intent={Intent.NONE} round>{level}</Tag>;
    }
  }

  render() {
    const filtered = this.state.logs.filter((log) => {
      const matchSearch = log.player.toLowerCase().includes(this.state.search.toLowerCase()) ||
        log.details.toLowerCase().includes(this.state.search.toLowerCase());
      const matchLevel = this.state.severityFilter === 'ALL' || log.level === this.state.severityFilter;
      return matchSearch && matchLevel;
    });

    return (
      <SideMenuWrapper>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h3 className="display-4 font-italic mb-1" style={{ fontSize: '1.5rem', color: '#182026' }}>
              Live Gateway & Security Server Logs
            </h3>
            <p className="text-muted m-0" style={{ fontSize: '0.85rem' }}>
              Real-time packet inspection, exploit shield logs, and server telemetry stream.
            </p>
          </div>

          <div className="d-flex gap-2">
            <Button
              icon={this.state.isStreaming ? 'pause' : 'play'}
              intent={this.state.isStreaming ? Intent.WARNING : Intent.SUCCESS}
              onClick={() => this.setState({ isStreaming: !this.state.isStreaming })}
              small
            >
              {this.state.isStreaming ? 'Pause Live Stream' : 'Resume Stream'}
            </Button>
            <Button icon="trash" intent={Intent.NONE} onClick={() => this.setState({ logs: [] })} small>
              Clear Screen
            </Button>
          </div>
        </div>

        {/* Telemetry Stat Cards */}
        <div className="row mb-4">
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Total Logs Analyzed</span>
              <h4 className="m-0" style={{ fontWeight: 800, color: '#182026' }}>148,920</h4>
            </Card>
          </div>
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Exploits Blocked Today</span>
              <h4 className="m-0 text-danger" style={{ fontWeight: 800 }}>14,210</h4>
            </Card>
          </div>
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Security Engine</span>
              <h4 className="m-0 text-success" style={{ fontWeight: 800 }}>STRICT GUARD</h4>
            </Card>
          </div>
          <div className="col-md-3">
            <Card elevation={Elevation.ONE} className="p-3">
              <span className="text-muted d-block text-uppercase" style={{ fontSize: '0.7rem', fontWeight: 700 }}>Stream Status</span>
              <h4 className="m-0 text-info" style={{ fontWeight: 800 }}>{this.state.isStreaming ? 'LIVE (Streaming)' : 'PAUSED'}</h4>
            </Card>
          </div>
        </div>

        {/* Search & Filter Bar */}
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
          <div className="d-flex gap-2">
            <Button
              active={this.state.severityFilter === 'ALL'}
              onClick={() => this.setState({ severityFilter: 'ALL' })}
              minimal
              small
              intent={Intent.PRIMARY}
            >
              All Events
            </Button>
            <Button
              active={this.state.severityFilter === 'EXPLOIT_BLOCKED'}
              onClick={() => this.setState({ severityFilter: 'EXPLOIT_BLOCKED' })}
              minimal
              small
              intent={Intent.DANGER}
            >
              Exploits Only
            </Button>
            <Button
              active={this.state.severityFilter === 'LOGIN'}
              onClick={() => this.setState({ severityFilter: 'LOGIN' })}
              minimal
              small
              intent={Intent.SUCCESS}
            >
              Logins
            </Button>
            <Button
              active={this.state.severityFilter === 'ALCHEMY'}
              onClick={() => this.setState({ severityFilter: 'ALCHEMY' })}
              minimal
              small
              intent={Intent.PRIMARY}
            >
              Alchemy
            </Button>
          </div>

          <div style={{ width: '240px' }}>
            <InputGroup
              leftIcon="search"
              placeholder="Search Log Details or IP..."
              value={this.state.search}
              onChange={(e) => this.setState({ search: e.target.value })}
              small
            />
          </div>
        </div>

        {/* Logs Table with Perfect Contrast */}
        <HTMLTable bordered condensed striped style={{ width: '100%', fontSize: '0.82rem' }}>
          <thead>
            <tr>
              <th style={{ color: '#182026' }}>Timestamp</th>
              <th style={{ color: '#182026' }}>Severity Level</th>
              <th style={{ color: '#182026' }}>Player / Account</th>
              <th style={{ color: '#182026' }}>IP Address</th>
              <th style={{ color: '#182026' }}>Log Event Details</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((log, idx) => (
              <tr key={idx}>
                <td className="font-mono" style={{ color: '#5c7080' }}>{log.time}</td>
                <td>{this.renderLevelTag(log.level)}</td>
                <td className="font-weight-bold" style={{ color: '#106ba3' }}>{log.player}</td>
                <td className="font-mono" style={{ color: '#5c7080' }}>{log.ip}</td>
                <td style={{ color: '#182026' }}>{log.details}</td>
              </tr>
            ))}
          </tbody>
        </HTMLTable>
      </SideMenuWrapper>
    );
  }
}
